<template>
  <div>
    <big-round-button :width="width" :height="height" v-if="!isModal" color="callout" to="/addCallout" icon="mdi-alert-outline"
                      text="ΝΕΑ ΒΛΑΒΗ"></big-round-button>
    <big-round-button :width="width" :height="height"  v-else color="callout" @click="dialog = true" icon="mdi-alert-outline"
                      text="ΝΕΑ ΒΛΑΒΗ"></big-round-button>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-toolbar dark color="secondary">
          <v-btn icon @click="dialog = false">
            <v-icon> mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title> Αναγγελία Βλάβης</v-toolbar-title>
        </v-toolbar>
        <domain-image class="mt-4 ml-4"
                      height="100" width="200"></domain-image>

        <callout-form class="mt-4" :branch_id="branch_id" :partner_id="partner_id" :project_id="project_id"
                      @calloutAdded="dialog = false"></callout-form>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import BigRoundButton from "@/components/BigRoundButton";
import {mapGetters, mapState} from "vuex";
import CalloutForm from "@/views/Events/components/CalloutForm";
import DomainImage from "@/components/DomainImage";

export default {
  name: "CalloutButton",
  components: {DomainImage, CalloutForm, BigRoundButton},
  data: () => ({
    dialog: false
  }),
  props: {
    height: {type: String, default: '100'},
    width: {type: String, default: '100'},
    isModal: {type: Boolean, default: null, required: false},
    branch_id: {type: Number, default: null, required: false},
    partner_id: {type: Number, default: null, required: false},
    project_id: {type: Number, default: null, required: false}
  },
  computed: {

    ...mapGetters(['isMobile'])
  }
}
</script>

<style scoped>

</style>
